// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"c6473e86e26e2f76","606":"8e298a0f7bb2e176","818":"3737c4d077beeaca"}[chunkId] + ".js";
};